export class OtpBean {

  otp: string;
}
